<app-loading *ngIf="contentReady"></app-loading>
<div>
  <div class="row p-0 gx-0">
    <div class="col-12 col-sm-12 main-content ">
      <div class="container-fluid mb-12 ">
        <div>


          <button routerLink="/addemployee" style="margin-left: 0;" class="first-btn btn btn-primary">
            {{ "New employee" | translate }}
          </button>


          <div class="card" *ngFor="let element of this.allData; index as i;">
            <div class="dropdown floting">
              <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton1"
                data-bs-toggle="dropdown" aria-expanded="false">
                <i class="fa-solid fa-ellipsis-vertical" style="font-size: larger;"></i>
              </button>
              <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                <li>
                  <a class="dropdown-item" (click)='edit(element)'>
                    {{ "Edit" | translate }} </a>
                </li>



                <li><a class="dropdown-item" (click)='deleteitem(element.id)'>
                    {{ "Delete" | translate }} </a></li>


              </ul>
            </div>
            <div class="card-body">
              <div class="avatar">
                <img src="/assets/emploees.png" alt="Company Logo">

              </div>

              <p class="card-text">


                <i class="fa-solid fa-user"></i>{{ "Name" | translate }}:{{element.name}}
              </p>
              <p class="card-text">


                <i class="fa-solid fa-user-tie"></i>
                {{ "job title" | translate }}:{{element.job_title}}
              </p>

              <p class="card-text"><i class="fa-solid fa-phone"></i>{{ "salary" | translate }}: {{element.salary}} {{
                "egp" | translate }}
              </p>
            </div>



            <div class="card-body">
              <div class="row">

                <div class="col-12">
                  <button class="card-link btn btn-primary" (click)='showEmployee(element)'>

                    {{ "employee details" | translate }}
                  </button>

                </div>


              </div>




            </div>
          </div>
        </div>
      </div>
    </div>
  </div>